// test685
(685 && 0);
